<div class="dashboard-content">
  <div class="title">
    <h2>Мои</h2>
    <h1>События</h1>
  </div>

    <app-events-calendar
            [displayPeriod]="'month'"
            [selectedEvent]="selectedEvent"
            (dateChange)="onSelectedDateChange($event)">

    </app-events-calendar>

    <div class="events-container">
      <div *ngIf="selectedDate" class="selected-date">{{ selectedDate.format("DD.MM.YYYY")}}</div>

                <div *ngFor="let event of events"
                     class="event-accordeon-wrapper">
                  <div  class="event-accordeon"  >
                    <div class="chevron-expand" (click)="openItem(event)">
                      <span class="lnr lnr-chevron-right" [class.opened]="event.isOpened"></span>
                    </div>
                    <div class="event-time">{{event.timeString}}</div>
                      <div class="event-name"><b>{{event?.serviceName}}</b>
                          <ng-container *ngIf="event?.description && event.serviceId != '2'">: {{event?.description}}</ng-container>
                          <ng-container *ngIf="event?.name && event.serviceId == '2'">: {{event?.name}}</ng-container>
                      </div>
                  </div>

                  <div class="event-panel"
                       [ngClass]="event.isOpened ? 'opened' :'closed' ">
                    <div *ngIf="event.serviceId != '1' && event.serviceId != '5'" class="event-room-line">{{event.comment || "Нет комментариев к услуге"}}</div>
                    <div *ngIf="event.serviceId == '1'">
                        <div *ngFor="let room of event.rooms" class="event-room-wrapper">
                            <div class="event-room-line">
                                <span class="event-room-const">Тип номера: </span> {{room.type}} <span class="event-room-const"> Количество номеров: </span>{{room.count}}  <br/>
                            </div>
                            <div class="event-room-line">
                                <span class="event-room-const">Жильцы: </span>{{room.tenants}} <br/>
                            </div>
                            <div class="event-room-line">
                                <span class="event-room-const">Комментарий: </span>{{event.comment ? event.comment : 'Комментариев нет' }}
                            </div>
                        </div>
                    </div>

<!--                      <div class="schedule-panel" [ngClass]="line.isOpened ? 'opened' :'closed' ">-->
<!--                          <div *ngIf="line.serviceTypeId == 1">-->
<!--                              <div class="comment-line"><span class="info-text">Тип номера: </span>{{line.roomType}} <span-->
<!--                                      class="info-text">Количество: </span> {{line.roomCount}}</div>-->
<!--                              <div class="comment-line"><span class="info-text">Жильцы: </span>{{line.tenants}}</div>-->
<!--                              <div class="comment-line"><span class="info-text">Комментарий: </span>{{line.comment}}</div>-->
<!--                          </div>-->
<!--                          <div *ngIf="line.serviceTypeId != 1 && line.serviceTypeId != 5">-->
<!--                              <div class="comment-line">{{line.comment ? line.comment : 'Комментариев нет'}}</div>-->
<!--                          </div>-->

<!--                          <div *ngIf="line.serviceTypeId == 5" >-->
<!--                              <ckeditor [disabled]="true" [editor]="Editor" [data]="line.comment ? line.comment : 'Комментариев нет'"-->
<!--                                        [config]="{ toolbar: [ ] }" class="ckeditor-view-comment"></ckeditor>-->
<!--                          </div>-->
<!--                      </div>-->

                      <div *ngIf="event.serviceId == '5'" >
                          <ckeditor [disabled]="true" [editor]="Editor" [data]="event.comment || 'Нет комментариев к услуге'"
                                    [config]="{ toolbar: [ ] }" class="ckeditor-view-comment"></ckeditor>
                      </div>
                  </div>

                </div>

                <div *ngIf="(!events || events.length===0) && isLoaded" class="event-wrapper">
                  <div class="no-events">Нет событий на выбранную дату</div>
                </div>

    </div>

</div>
